import React from 'react'

import OrangeButton from '../../../../components/Buttons/OrangeButton'
import StorageCard from './StorageCard'

import { storageServices } from '../../../../constants'

const StorageSettings = () => {
  const connectedServices = storageServices.filter((service) => service.connected)
  const unconnectedServices = storageServices.filter((service) => !service.connected)

  const handleSave = () => {}

  const connectedServicesContent = connectedServices.map((connectedService) => {
    return <StorageCard key={connectedService.name} service={connectedService} />
  })

  const unconnectedServicesContent = unconnectedServices.map((unconnectedService) => {
    return <StorageCard key={unconnectedService.name} service={unconnectedService} />
  })

  return (
    <div className="w-full pb-16">
      <h3 className="text-primary-100 text-2xl font-bold rounded-[10px] bg-[#FEEBDD] p-[20px]">
        Storage Integration Settings
      </h3>

      <div className="mt-[20px] bg-[#FEEBDD] rounded-[10px] p-8">
        <h4 className="text-sm font-normal text-primary-100">
          All of your storage services connected with Apolo P2P are displayed here:
        </h4>

        <div className="mt-[20px] p-[20px] border-[1px] border-solid border-[#FFCA84] rounded-[10px]">
          <h5 className="text-base text-primary-100 font-bold">Connected Services</h5>

          <div className="w-full flex flex-wrap items-start mt-[8px] gap-x-[20px]">
            {connectedServicesContent}
          </div>
        </div>

        <div className="mt-[20px] p-[20px] border-[1px] border-solid border-[#FFCA84] rounded-[10px]">
          <h5 className="text-base text-primary-100 font-bold">Other Services</h5>

          <div className="w-full flex flex-wrap items-start mt-[8px] gap-x-[20px]">
            {unconnectedServicesContent}
          </div>
        </div>

        <OrangeButton text="Save Changes" className="mt-[20px]" onClick={handleSave} />
      </div>
    </div>
  )
}

export default StorageSettings
